app = angular.module("seismology")

app.controller "LearnCtrl", ($scope, Lesson, Chars, LessonProgress, TutorialDialog) ->
  $scope.kanaLessons = Lesson.getKanaLessons()
  $scope.kanjiLessons = Lesson.getKanjiLessons()
  $scope.progress = {}
  LessonProgress.getList().$loaded (progress) ->
    for p in progress
      $scope.progress[p.$id] = p.$value
  $scope.openTutorial = (number)->
    TutorialDialog.show(number)
  
  
app.controller "LessonCtrl", ($scope, $stateParams, $window, $mdDialog, Lesson, Chars) ->

  
  id = $stateParams.id
  $scope.lesson = Lesson.get(id)
  chars = Chars.getByLessonId(id)
  $scope.chars = chars
  $scope.selectChar = (index) ->
    $scope.selected = $scope.chars[index]
  $scope.startQuiz = ->
    $mdDialog.show
      controller: ($scope) ->
        $scope.lessonId = id
        $scope.chars = chars
        $scope.cancel = -> $mdDialog.hide()
        $scope.start = (size, askAllChars=false) ->
          $mdDialog.show
            controller: 'QuizCtrl'
            templateUrl: 'templates/kula/quiz_dialog.html'
            parent: angular.element(document.body)
            clickOutsideToClose: false
            locals: {lessonId: id, size: size, askAllChars: askAllChars}
      templateUrl: 'templates/kula/start_quiz_dialog.html'
      parent: angular.element(document.body)
      clickOutsideToClose:true


  
app.controller "CharCtrl", ($scope, $stateParams, Chars, QuizState) ->
  id = parseInt($stateParams.char_id)
  $scope.char = Chars.get(id)
  

app.controller "QuizCtrl", ($scope, $timeout, $mdDialog, Quiz, QuizState, Lesson, LessonProgress, CurrentUser, NotificationMsg, lessonId, size, askAllChars) ->
  $scope.lesson = Lesson.get(lessonId)
  gemCount =
    unless askAllChars
      if size <= 10 then 1 else 2
    else
      if size <= 10 then 3 else 5

  $scope.quiz =
    input: ""
    progress: 0
    size: size
    correct: 0
    askAllChars: askAllChars   
    quizArray: Quiz.getByLessonId(lessonId)

  $scope.insertChar = (char) ->
    $scope.quiz.input ||= ""
    $scope.quiz.input += char

  $scope.quiz.quizArray.$loaded ->
    $scope.quiz.current = $scope.quiz.quizArray.getQuizAt(0, askAllChars)
    QuizState.setState('asking')
    $scope.state = QuizState.getState()
    $scope.$broadcast('focus-input')
    $scope.answerLength= if askAllChars then 10 else 1

  $scope.proceed = ->          
    return if $scope.state.showActionButton    
    $scope.state = QuizState.proceed($scope.quiz)
    # 8割以上正解の際には成績を記録する
    if $scope.state.isCleared
      LessonProgress.setGemCount(lessonId, gemCount).then ->
        CurrentUser.get().updateGemCount().then ->
          NotificationMsg.show("宝石を#{gemCount}個獲得しました")        
    if $scope.state.waitFor
      proceed = => $scope.proceed()
      $timeout(proceed, $scope.state.waitFor)      
    if $scope.state.input
      $scope.$broadcast('focus-input')
  
  $scope.cancel = ->
    $mdDialog.hide()

  

app.controller 'TutorialDialogCtrl' , ($scope, $mdDialog, speech) ->
  console.log speech
  $scope.idx = 0
  $scope.length = speech.length
  $scope.currentSpeech = speech[$scope.idx]
  $scope.title = 'チュートリアル'
  $scope.proceed = ->
    if $scope.idx < speech.length-1
      $scope.idx += 1
      $scope.currentSpeech = speech[$scope.idx]
  $scope.rollback = ->
    if $scope.idx > 0
      $scope.idx -= 1
      $scope.currentSpeech = speech[$scope.idx]
  $scope.cancel = ->
    $mdDialog.hide()
  



// WEBPACK FOOTER //
// ./app/controllers/learn_controllers.coffee